import img00 from "../../img/halong-bay-vietnam.jpg";
import img01 from "../../img/arashiyama-japan.jpg";
import img02 from "../../img/bagan-myanmar.jpg";
import img03 from "../../img/grand-canyon-usa.jpg";
import img04 from "../../img/hallstatt-austria.jpg";
import img05 from "../../img/hamnoy-norway.jpg";
import img06 from "../../img/kyoto-japan.jpg";
import img07 from "../../img/plitvice-lakes-croatia.jpg";
import img08 from "../../img/neuschwanstein-castle-germany.jpg";
import img09 from "../../img/white-sands-usa.jpg";

const data = [
  {
    name: "Halong Bay",
    location: "Vietnam",
    description:
      "A beautiful natural wonder in northern Vietnam near the Chinese border. The Bay is dotted with 1,600 limestone islands and islets and covers an area of over 1,500 sqkm. This extraordinary area was declared a UNESCO World Heritage Site in 1994.",
    image: img00,
  },
  {
    name: "Arashiyama Bamboo Grove",
    location: "Japan",
    description:
      "Arashiyama's Sagano Bamboo Forest, or Bamboo Grove, is both locally famous and world-renowned. Visitors can stroll paths lined with endless rows of towering bamboo. The experience has been described as other-worldly, serene, and dreamlike.",
    image: img01,
  },
  {
    name: "Bagan",
    location: "Myanmar",
    description:
      "An ancient city on the Irrawaddy River in Myanmar (Burma), was once home to over 13,000 brick temples built between the 9th and 13th centuries. Over the centuries, most of the temples have been destroyed by earthquakes, man, or time.",
    image: img02,
  },
  {
    name: "Grand Canyon",
    location: "Arizona, USA",
    description:
      "The Grand Canyon is indeed a very big hole in the ground. It is 277 miles (446 km) long, up to 18 miles (29 km) wide and more than a mile (6,000 feet / 1,800 meters) deep. It is the result of constant erosion by the Colorado River over millions of years.",
    image: img03,
  },
  {
    name: "Hallstatt",
    location: "Austria",
    description:
      "A little town of breathtaking views located between Salzburg and Graz, in the Salzkammergut Lake District of Austria. Considered to be one of the oldest still inhabited settlement in Europe, Hallstatt is a UNESCO heritage site and an important Austrian tourist attraction",
    image: img04,
  },
  {
    name: "Hamnoy",
    location: "Norway",
    description:
      "A small fishing village in Moskenes Municipality in Nordland county, Norway. It is located on the eastern side of the island of Moskenesøya, about 1.5 kilometres (0.93 mi) northeast of the village of Reine, along the Vestfjorden.",
    image: img05,
  },
  {
    name: "Kyoto",
    location: "Japan",
    description:
      "Located in the Kansai region of Japan, is the country's seventh largest city, with a population of 1.4 million people. Steeped in history, Kyoto is home to roughly one quarter of Japan's national treasures, countless shrines and temples, and seventeen sites recognized by UNESCO as World Heritage Sites.",
    image: img06,
  },
  {
    name: "Plitvice Lakes",
    location: "Croatia",
    description:
      "The oldest and largest national park in the Republic of Croatia. The park is situated in the mountainous region of Croatia, between the Mala Kapela mountain range in the west and northwest, and the Lička Plješivica mountain range to the southeast.",
    image: img07,
  },
  {
    name: "Neuschwanstein Castle",
    location: "Germany",
    description:
      'One of the most visited castles in Germany and one of the most popular tourist destinations in Europe. The castle is located in Bavaria, near the town of Fussen. It was built by King Ludwig II of Bavaria, also known as the "Fairytale King".',
    image: img08,
  },
  {
    name: "White Sands",
    location: "New Mexico, USA",
    description:
      "Rising from the heart of the Tularosa Basin is one of the world's great natural wonders - the glistening white sands of New Mexico. Great wave-like dunes of gypsum sand have engulfed 275 square miles of desert, creating the world's largest gypsum dunefield.",
    image: img09,
  },
];

export default data;
